import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { downgradeComponent } from '@angular/upgrade/static';
import { StateProvider } from '@uirouter/angularjs';
import * as angular from 'angular';
import { TutorialModule } from '../tutorial/tutorial.module';
import { IndicatorsRoutingModule } from './indicators-routing.module';
import { IndicatorsComponent } from './indicators/indicators.component';

@NgModule({
  imports: [
    IndicatorsRoutingModule,
    CommonModule,
    FormsModule,
    TutorialModule,
  ],
  declarations: [IndicatorsComponent]
})
export class IndicatorsModule { }

try {
  angular.module('mandaeApp')
    .directive('indicadores', downgradeComponent({ component: IndicatorsComponent }))
    .config([
      '$stateProvider', ($stateProvider: StateProvider) => {
        $stateProvider
          .state({
            name: 'indicadores',
            url: '/indicadores?tour',
            component: 'indicadores',
          });
      }
    ]);
} catch (e) { }
